/* global __webpack_public_path__ */ // ✅ Tell ESLint it's a global

import React from "react"
import { Toaster } from "react-hot-toast"

import Layout from "./src/Layout/Layout"
import "./src/Digiflow/scss/main.scss"
import Scripts from "./src/Layout/Scripts"
import { CwvProvider, LocaleContext } from "./src/context/context"
import { SaaSProvider } from "./src/context/SaaSContext"

// ✅ Move this below imports
export const onClientEntry = () => {
  const path = window.location.pathname

  // If visiting under localized routes, make Webpack load chunks from root "/"
  if (
    path.startsWith("/in/en/") ||
    path.startsWith("/jp/ja/") ||
    path.startsWith("/mena/ar/") ||
    path.startsWith("/mena/en/") ||
    path.startsWith("/uk/en/")
  ) {
    __webpack_public_path__ = "/"
  }
}

export const wrapPageElement = ({ element, props }) => {
  const { node_locale, multiLang, isLandingPage } =
    props.pageContext || {}

  return (
    <LocaleContext.Provider value={{ locale: node_locale, multiLang }}>
      <>
        <Scripts isLandingPage={isLandingPage} />
        <CwvProvider>
          <Layout isLandingPage={isLandingPage}>{element}</Layout>
        </CwvProvider>
        <Toaster position="top-center" />
      </>
    </LocaleContext.Provider>
  )
}

export const wrapRootElement = ({ element }) => {
  return (
    <SaaSProvider>
      {element}
    </SaaSProvider>
  )
}
